import * as React from "react";

const SvgIcnEmail = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M19 6a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h14zm0 3.543l-6.41 2.748a1.5 1.5 0 01-1.18 0L5 9.544V17h14V9.543zM19 7H5v1.456l6.803 2.916a.5.5 0 00.394 0L19 8.455V7z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnEmail;
